
import { useEffect, useState } from "react";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutTabla } from "../../layouts";
import { separadorMillares } from "../../../hooks";
import { useParams } from "react-router-dom";
import { useOPXID } from "../../../hooks/cache";


export const TablaReporteInventarioTotales = ({ datos }) => {


    const { id } = useParams();
    const { data } = useOPXID(id);  
    const [totales, setTotales] = useState({ utilidad:0, gasto:0 });


    useEffect(() => {
        if(datos.length > 0){
            const gasto = datos.reduce((t,a) => t + Number(a.precio) * Math.abs(Number(a.cantidad)), 0);
            const utilidad = (data?.totalOrden || 0) - gasto;
            setTotales({ utilidad, gasto })
        }
    }, [datos])
    


    return (
        <>
        {(datos.length > 0) &&
        <LayoutTabla mb={2}>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width:'25%'}}>Items</TableCell>
                    <TableCell sx={{width:'25%'}}>Total Orden</TableCell>
                    <TableCell sx={{width:'25%'}}>Gasto</TableCell>
                    <TableCell sx={{width:'25%'}}>Utilidad</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                <TableRow>
                    <TableCell>{ datos.length }</TableCell>
                    <TableCell>{ `$${separadorMillares(data.totalOrden)}` }</TableCell>
                    <TableCell>{ `$${separadorMillares(totales.gasto)}` }</TableCell>
                    <TableCell>{ `$${separadorMillares(totales.utilidad)}` }</TableCell>
                </TableRow>
            </TableBody>
        </LayoutTabla>
        }
        </>
    )
}